"use client"

import { FC } from "react"
import { Link } from "utils"
import type { SearchResult } from "./index"
import ChevronLeft from "../../icons/ChevronLeft"
import { LogoMark } from "../SearchPage/icons"
import {
  ResultsWrapper,
  ResultCountText,
  ResultItem,
  ResultInfo,
  ResultTitle,
  ResultDescription,
  ResultThumbnail,
  ResultThumbnailFallback,
  ArrowIconWrapper,
} from "./styles"

interface ResultsProps {
  results: SearchResult[]
  countLabel: string
  onItemClick: () => void
}

const Results: FC<ResultsProps> = ({ results, countLabel, onItemClick }) => (
  <ResultsWrapper>
    <ResultCountText>{countLabel}</ResultCountText>
    {results.map((item) => (
      <ResultItem key={item.url}>
        <Link href={item.url} onClick={onItemClick}>
          {item.thumbnail ? (
            <ResultThumbnail src={item.thumbnail} alt="" />
          ) : (
            <ResultThumbnailFallback aria-hidden="true">
              <LogoMark />
            </ResultThumbnailFallback>
          )}
          <ResultInfo>
            <ResultTitle>{item.title}</ResultTitle>
            {item.description && (
              <ResultDescription>{item.description}</ResultDescription>
            )}
          </ResultInfo>
          <ArrowIconWrapper>
            <ChevronLeft />
          </ArrowIconWrapper>
        </Link>
      </ResultItem>
    ))}
  </ResultsWrapper>
)

export default Results
